import styled from 'styled-components';

export const SideMenuItemContainer = styled.div`
  cursor: pointer;
`;
